export default {
  title: 'Rapport over underskrevne / live',
  column_groups: {
    current_period: 'Nuværende periode',
  },
  fields: {
    name: 'Navn',
    area: 'Område',
    signed: 'Underskrevet',
    live: 'Live',
    going_live: 'Går live',
    going_live_avg: 'Gns. går live',
    churned: 'Opsagt',
    not_live: 'Ikke live',
    live_ratio: 'Live-andel',
    avg_mrr: 'Gns. MRR',
  },
  manager_status_filters: {
    active: 'Aktiv',
    inactive: 'Inaktiv',
    all: 'Alle',
  },
  status_filters: {
    all: 'Alle',
    not_live: 'Ikke live',
  },
  drawer: {
    title: '{{column}} — {{managerName}}',
    subtitle_one: '{{count}} restaurant',
    subtitle_other: '{{count}} restauranter',
    empty: 'Ingen restauranter fundet.',
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses, opdater siden',
  },
};
